import { notification } from 'antd';

export const toastNotification = ({ title, description, status }) => {
  // Verificar si hay undefined
  if (title === undefined || description === undefined) {
    return; 
  }
  // Mapear el status al tipo de notificación de Ant Design
  const notificationType = status || 'info';
  notification.open({
    message: title,
    description: description,
    duration: 4.5,
    placement: 'topRight',
  });
};

export const sendNativeNotification = ({ title, body }) => {
  
  // Verificar si hay undefined
  if (title === undefined || body === undefined) {
    return;
  }
  
  if (!('Notification' in window)) {
    return;
  }
  
  // Verificar permisos
  if (Notification.permission === 'granted') {
    new Notification(title, { body });
  } else if (Notification.permission !== 'denied') {
    Notification.requestPermission().then(permission => {
      if (permission === 'granted') {
        new Notification(title, { body });
      }
    });
  }
};